export const API_KEY_PERMISSION_WRITE = 'write';
export const API_KEY_PERMISSION_PROFILES = 'profiles';
const API_KEY_PERMISSION_BASE_STATIONS = 'base_stations';

const DOMAIN_API_KEY_PERMISSIONS = [
	API_KEY_PERMISSION_PROFILES,
	API_KEY_PERMISSION_BASE_STATIONS,
];

export const hasDomainPermission = permissions => {
	if (!permissions || permissions.length === 0) {
		return false;
	}
	return DOMAIN_API_KEY_PERMISSIONS.some(permission => permissions.includes(permission));
};

export const buildPermissionsPreviewKeys = permissions => {
	if (!permissions || permissions.length === 0) {
		return ['noPermissions'];
	}
	const hasWrite = permissions.includes(API_KEY_PERMISSION_WRITE);
	const previewKeys = [];
	if (permissions.includes(API_KEY_PERMISSION_PROFILES)) {
		previewKeys.push(hasWrite ? 'readWriteProfiles' : 'readProfiles');
	}
	if (permissions.includes(API_KEY_PERMISSION_BASE_STATIONS)) {
		previewKeys.push(hasWrite ? 'readWriteBaseStations' : 'readBaseStations');
	}
	if (previewKeys.length === 0) {
		return ['noPermissions'];
	}
	return previewKeys;
};
